var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":""},on:{"click":_vm.generateCharacter}},[_c('v-list-item-title',[_vm._v("Shuffle")]),_c('v-list-item-icon',[_c('v-icon',[_vm._v("cached")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }